import { jwtDecode } from "jwt-decode";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Button,
    Form,
    Input,
    InputGroup,

} from "reactstrap";


const defaultValue = {
    visit: "",
    vc_reference: "",
    lab_order_no: ""
};


//Import Breadcrumb
import { getPatientsByClinicId, getClinic, getPCAREByVisitId, getVisitsByPatientId, getNextInvoiceNo, addInvoiceNew, getJobByVisit, getLabOrderByVcReference, searchTariffs } from "service/api";

const Invoice_new = () => {
    const [Invoice, setInvoice] = useState(defaultValue)
    const [invoiceNo, setInvoiceNo] = useState('')
    const [labOrder, setgetLab] = useState([])
    const [subtotal, setSubtotal] = useState('0.00')
    const [discountType, setDiscountType] = useState('percent')   // 'percent' | 'amount'
    const [discountValue, setDiscountValue] = useState('0')
    const [vatPercent, setVatPercent] = useState('15')
    const [total, setTotal] = useState('0.00')
    const [formRows, setFormRows] = useState([
        { id: 1, eye: 'Right', lens: '', status: '', spherical: '', cylinder: '', axis: '', add: '', prism: '' },
        { id: 2, eye: 'Left', lens: '', status: '', spherical: '', cylinder: '', axis: '', add: '', prism: '' }
    ]);

    const [formRows2, setFormRows2] = useState([{ id: 1, qty: '', line_type: '', description: '', tarif_code: '', diag_code: '', price_info: '' }]);
    const [errors, setErrors] = useState({});
    const [patients, setPatients] = useState([]);
    const [visits, setVisits] = useState([]);
    const [pcareData, setPcareData] = useState(null);
    const [labLensDetails, setLabLensDetails] = useState(null);
    const [frameDetails, setFrameDetails] = useState(null);
    const [tariffOptionsByRow, setTariffOptionsByRow] = useState({});
    const [loading, setLoading] = useState(true);
    const [selectedGroup, setselectedGroup] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [clinics, setClinics] = useState([]);
    const [selectedClinicId, setSelectedClinicId] = useState("");
    const onAddFormRow = () => {
        const newRow = {
            id: formRows.length + 1,
            eye: '',
            lens: '',
            status: '',
            spherical: '',
            cylinder: '',
            axis: '',
            add: '',
            prism: '',
        };
        setFormRows([...formRows, newRow]);
    };

    const onDeleteFormRow = (id) => {
        if (id !== 1) {
            // Delete the row
            const newRows = formRows.filter(row => row.id !== id);
            setFormRows(newRows);

            // Recalculate the total after deletion
            const newTotal = newRows.reduce((acc, row) => acc + parseFloat(row.total), 0);
            setTotal(newTotal.toFixed(2));
        }
    };

    const onAddFormRow2 = () => {
        const newRow = {
            id: formRows2.length + 1,
            qty: '',
            line_type: '',
            description: '',
            tarif_code: '',
            diag_code: '',
            price_info: '',
        };
        setFormRows2([...formRows2, newRow]);
    };
    const onDeleteFormRow2 = (id) => {
        if (id !== 1) {
            // Delete the row
            const newRows = formRows2.filter(row => row.id !== id);
            setFormRows2(newRows);

            // Recalculate the total after deletion
            const newTotal = newRows.reduce((acc, row) => acc + parseFloat(row.total), 0);
            setTotal(newTotal.toFixed(2));
        }
    };

    useEffect(() => {
        getPatientAll();
        fetchNextInvoiceNo();
    }, [])

    const fetchNextInvoiceNo = async () => {
        try {
            const res = await getNextInvoiceNo();
            if (res?.data?.invoice_no) {
                setInvoiceNo(res.data.invoice_no);
            }
        } catch (err) {
            console.error('Error fetching invoice number', err);
        }
    };

    useEffect(() => {
        if (pcareData) {
            const updatedRows = [
                {
                    id: 1,
                    eye: 'OD (R)', // optional
                    lens: '',
                    status: '',
                    spherical: pcareData.Prescription_right_sphere || '',
                    cylinder: pcareData.Prescription_right_cyl || '',
                    axis: pcareData.Prescription_right_axis || '',
                    add: pcareData.Prescription_right_add || '',
                    prism: pcareData.Prescription_right_prism || ''
                },
                {
                    id: 2,
                    eye: 'OS (L)', // optional
                    lens: '',
                    status: '',
                    spherical: pcareData.Prescription_left_sphere || '',
                    cylinder: pcareData.Prescription_left_cyl || '',
                    axis: pcareData.Prescription_left_axis || '',
                    add: pcareData.Prescription_left_add || '',
                    prism: pcareData.Prescription_left_prism || ''
                }
            ];
            setFormRows(updatedRows);
        }
    }, [pcareData]);


    const getPatientAll = async () => {
        try {
            const token = localStorage.getItem("token");
            if (token) {
                const decoded = jwtDecode(token);
                const clinicID = decoded?.clinicID;

                if (clinicID) {
                    // Clinic login — auto-select clinic, load its patients
                    setIsAdmin(false);
                    setSelectedClinicId(clinicID);
                    const response = await getPatientsByClinicId(clinicID);
                    setPatients(response?.data?.data || []);
                } else {
                    // Admin login — load all clinics for dropdown, no patients yet
                    setIsAdmin(true);
                    const clinicRes = await getClinic();
                    setClinics(clinicRes?.data || []);
                    setPatients([]);
                }
            }
        } catch (error) {
            console.log("Error while fetching patient data:", error);
            setPatients([]);
        } finally {
            setLoading(false);
        }
    };

    const handleClinicSelect = async (e) => {
        const clinicId = e.target.value;
        setSelectedClinicId(clinicId);
        setselectedGroup(null);
        setPatients([]);
        setVisits([]);
        if (clinicId) {
            try {
                const response = await getPatientsByClinicId(clinicId);
                setPatients(response?.data?.data || []);
            } catch (err) {
                console.log("Error fetching patients for clinic:", err);
            }
        }
    };


    function handleSelectGroup(selectedOption) {
        setselectedGroup(selectedOption);

        const selectedPatient = patients.find(p => p._id === selectedOption.value);
        console.log("Selected patient:", selectedPatient);

        // Get visits for the selected patient
        fetchVisitsByPatientId(selectedOption.value);
    }


    const fetchVisitsByPatientId = async (patientId) => {
        try {
            const res = await getVisitsByPatientId(patientId);
            if (Array.isArray(res.data)) {
                console.log("✅ Fetched Visits:", res.data);
                setVisits(res.data); // directly use res.data
            } else {
                console.warn("⚠️ Visit data is not an array:", res.data);
                setVisits([]);
            }
        } catch (err) {
            console.error("❌ Error fetching visits", err);
            setVisits([]);
        }
    };
    const onValueChange = async (e) => {
        const { name, value } = e.target;

        if (name === "visit") {
            let nextPcareData = null;
            try {
                const response = await getPCAREByVisitId(value);
                if (response?.data) {
                    console.log("✅ PCARE Data:", response.data);
                    // Make sure you're setting the first item if it's an array
                    nextPcareData = Array.isArray(response.data) ? response.data[0] : response.data;
                    setPcareData(nextPcareData);
                } else {
                    console.warn("No PCARE data found");
                    setPcareData(null);
                }
            } catch (err) {
                console.error("Error fetching PCARE data", err);
                setPcareData(null);
            }

            let matchedJob = null;
            let matchedLab = null;
            let vcReference = "";

            try {
                const jobRes = await getJobByVisit(value);
                matchedJob = jobRes?.data || null;
                vcReference = (matchedJob?.vc_reference || "").trim();
                console.log("[Invoice] visit selected:", value);
                console.log("[Invoice] matched job by visit:", matchedJob);
                console.log("[Invoice] vc_reference from job:", vcReference);
            } catch (err) {
                console.error("Error fetching job by visit", err?.response?.data || err);
            }

            try {
                if (vcReference) {
                    const labRes = await getLabOrderByVcReference(vcReference);
                    matchedLab = labRes?.data || null;
                    console.log("[Invoice] matched lab by vc_reference:", matchedLab);
                }
            } catch (err) {
                console.error("Error fetching lab order by vc reference", {
                    vcReference,
                    error: err?.response?.data || err,
                });
            }

            setgetLab(matchedLab ? [matchedLab] : []);

            const nextInvoiceState = {
                ...Invoice,
                [name]: value,
                vc_reference: vcReference,
                lab_order_no: matchedLab?.order_no || "",
            };
            setInvoice(nextInvoiceState);

            if (matchedLab) {
                setLabLensDetails({
                    lensCode: matchedLab.lenscode || nextPcareData?.lens_code || "",
                    orderNo: matchedLab.order_no || "",
                    od: {
                        lensType: matchedLab.lens_type_od || "",
                        totalPrice: matchedLab.total_od || "",
                        photo: matchedLab.extra_od === "yes" ? "Yes" : "No",
                        material: matchedLab.lens_material_od || "",
                    },
                    os: {
                        lensType: matchedLab.lens_type_os || "",
                        totalPrice: matchedLab.total_os || "",
                        photo: matchedLab.extra_os === "yes" ? "Yes" : "No",
                        material: matchedLab.lens_material_os || "",
                    },
                });
            } else {
                setLabLensDetails(null);
            }

            if (matchedLab && matchedLab.frame_brand) {
                setFrameDetails({
                    frameBrand: matchedLab.frame_brand || "",
                    frameColor: matchedLab.frame_color || "",
                    frameSize: matchedLab.frame_size || "",
                    frameMaterial: matchedLab.frame_material || "",
                    frameType: matchedLab.frame_type || "",
                    frameShape: matchedLab.frame_shape || "",
                    frameCode: matchedLab.framecode || "",
                    framePrice: matchedLab.frame_price || "",
                });
            } else {
                setFrameDetails(null);
            }
            return;
        }

        // Update other form fields if needed
        setInvoice(prev => ({ ...prev, [name]: value }));
    };

    const handleFormFieldChange = (id, e) => {
        const { name, value } = e.target;
        const updatedRows = formRows.map(row =>
            row.id === id ? { ...row, [name]: value } : row
        );
        setFormRows(updatedRows);
    };

    const getLabLensSubtotal = () => {
        const od = parseFloat(labLensDetails?.od?.totalPrice) || 0;
        const os = parseFloat(labLensDetails?.os?.totalPrice) || 0;
        return od + os;
    };

    const getFrameSubtotal = () => {
        return parseFloat(frameDetails?.framePrice) || 0;
    };

    // Central recalculator — call whenever rows, discount, or vat changes
    const recalculate = (rows, dType, dValue, vatPct) => {
        const rowSub = rows.reduce((acc, row) => {
            return acc + (parseFloat(row.price_info) || 0) * (parseFloat(row.qty) || 1);
        }, 0);
        const sub = rowSub + getLabLensSubtotal() + getFrameSubtotal();
        const discAmt = dType === 'percent'
            ? sub * (parseFloat(dValue) || 0) / 100
            : (parseFloat(dValue) || 0);
        const afterDiscount = Math.max(sub - discAmt, 0);
        const vatAmt = afterDiscount * (parseFloat(vatPct) || 0) / 100;
        const grand = afterDiscount + vatAmt;
        setSubtotal(sub.toFixed(2));
        setTotal(grand.toFixed(2));
        return { sub, discAmt, vatAmt, grand };
    };

    useEffect(() => {
        recalculate(formRows2, discountType, discountValue, vatPercent);
    }, [labLensDetails, frameDetails]);

    const handleFormRow2Change = (id, e) => {
        const { name, value } = e.target;
        const updatedRows = formRows2.map(row =>
            row.id === id ? { ...row, [name]: value } : row
        );
        setFormRows2(updatedRows);
        recalculate(updatedRows, discountType, discountValue, vatPercent);
    };

    const loadTariffOptions = async (rowId, inputValue = "") => {
        try {
            const res = await searchTariffs(inputValue);
            const options = (res?.data || []).map(item => ({
                value: item.tariff_code,
                label: `${item.tariff_code} - ${item.description}`,
                tariff: item,
            }));
            setTariffOptionsByRow(prev => ({ ...prev, [rowId]: options }));
        } catch (error) {
            console.error("Error loading tariff options", error);
            setTariffOptionsByRow(prev => ({ ...prev, [rowId]: [] }));
        }
    };

    const handleTariffSelect = (rowId, selectedOption) => {
        const tariff = selectedOption?.tariff;
        const updatedRows = formRows2.map(row =>
            row.id === rowId
                ? {
                    ...row,
                    qty: tariff ? '1' : '',
                    line_type: tariff?.tariff_code || '',
                    description: tariff?.description || '',
                    tarif_code: tariff?.tariff_code || '',
                    price_info: tariff?.price !== undefined && tariff?.price !== null ? String(tariff.price) : '',
                }
                : row
        );
        setFormRows2(updatedRows);
        recalculate(updatedRows, discountType, discountValue, vatPercent);
    };

    const handleDiscountTypeChange = (e) => {
        const val = e.target.value;
        setDiscountType(val);
        recalculate(formRows2, val, discountValue, vatPercent);
    };

    const handleDiscountValueChange = (e) => {
        const val = e.target.value;
        setDiscountValue(val);
        recalculate(formRows2, discountType, val, vatPercent);
    };

    const handleVatChange = (e) => {
        const val = e.target.value;
        setVatPercent(val);
        recalculate(formRows2, discountType, discountValue, val);
    };

    const addInvoiceDetails = async (e) => {
        e.preventDefault();
        try {
            // ── Recompute fresh at save time (avoids stale React state closure) ──
            const _rowSub = formRows2.reduce((acc, row) =>
                acc + (parseFloat(row.price_info) || 0) * (parseFloat(row.qty) || 1), 0);
            const _sub = _rowSub + getLabLensSubtotal() + getFrameSubtotal();
            const _dv = parseFloat(discountValue) || 0;
            const _discAmt = discountType === 'percent' ? _sub * _dv / 100 : _dv;
            const _after = Math.max(_sub - _discAmt, 0);
            const _vatAmt = _after * (parseFloat(vatPercent) || 0) / 100;
            const _grand = _after + _vatAmt;

            const payload = {
                invoice_type: Invoice.invoice_type || '',
                clinic_id: selectedClinicId || null,
                patient_id: selectedGroup?.value || null,
                visit_id: Invoice.visit || null,
                treating_provider: Invoice.treating_provider || '',
                service_date: Invoice.service_date || '',
                service_place: Invoice.service_place || '',
                diagnosis_code: Invoice.diagnosis_code || '',
                vc_reference: Invoice.vc_reference || '',
                lab_order_no: Invoice.lab_order_no || '',
                od_lens_price: labLensDetails?.od?.totalPrice || '0.00',
                os_lens_price: labLensDetails?.os?.totalPrice || '0.00',
                frame_price: frameDetails?.framePrice || '0.00',
                script_rows: formRows,
                invoice_rows: formRows2,
                subtotal: _sub.toFixed(2),
                discount_type: discountType,
                discount_value: String(_dv),
                discount_amount: _discAmt.toFixed(2),
                vat_percent: String(vatPercent),
                vat_amount: _vatAmt.toFixed(2),
                total_amount: _grand.toFixed(2),
            };
            const res = await addInvoiceNew(payload);
            if (res?.status === 201) {
                navigate('/List/Invoice');
            } else {
                alert('Failed to save invoice');
            }
        } catch (err) {
            console.error('Error saving invoice', err);
            alert('Error saving invoice');
        }
    };

    const navigate = useNavigate();

    //meta title
    document.title = "INVOICE | Form";

    return (
        <React.Fragment>
            {/* <div className="page-content"> */}
            <Container fluid>
                <Row>
                    <Card>
                        <CardBody>
                            <Form className="p-2" style={{ border: "0.5px solid #ddd", borderRadius: "4px", backgroundColor: "#f9f9f9" }}>
                                <Row>
                                    <Col
                                        md={12}
                                        style={{
                                            borderRight: "15px solid #ffff", // Adjust thickness and color here
                                            paddingRight: "10px",
                                            borderImage: "linear-gradient(to bottom, #ffff, #ffff) 1", // Optional gradient effect
                                        }}
                                    >
                                        <br /><br /><br />
                                        <div className="mb-4 d-flex justify-content-between align-items-center">
                                            <h4 style={{ fontWeight: "bold", textAlign: "left", color: "#f46a6a", margin: 0 }}>Capture Invoice</h4>
                                            <Link to="/List/Invoice" className="btn btn-danger btn-sm">
                                                <i className="mdi mdi-format-list-bulleted me-1"></i> Invoice List
                                            </Link>
                                        </div>
                                        <Row>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-invoiceNo" style={{ fontWeight: "bold" }}>Invoice No</Label>
                                                    <Input type="text" className="form-control" value={invoiceNo} disabled style={{ backgroundColor: "#e9f7ef", fontWeight: "bold", color: "#155724" }} />
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-referenceNo" style={{ fontWeight: "bold" }}>
                                                        Invoice type
                                                    </Label>
                                                    <select name="invoice_type" className="form-control" onChange={(e) => onValueChange(e)}>
                                                        <option defaultValue>Choose...</option>
                                                        <option >Cash</option>
                                                        <option >Credit Card</option>
                                                        <option >Medical Aid</option>
                                                    </select>
                                                </div>
                                            </Col>
                                            {isAdmin && (
                                                <Col md={4}>
                                                    <div className="mb-3">
                                                        <Label style={{ fontWeight: "bold" }}>Select Practice</Label>
                                                        <select className="form-control" value={selectedClinicId} onChange={handleClinicSelect}>
                                                            <option value="">Choose parctice...</option>
                                                            {clinics.map(c => (
                                                                <option key={c._id} value={c._id}>{c.name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </Col>
                                            )}
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-referenceNo" style={{ fontWeight: "bold" }}>
                                                        Select Patient
                                                    </Label>
                                                    <Select
                                                        value={selectedGroup}
                                                        onChange={handleSelectGroup}
                                                        options={patients.map((patient) => ({
                                                            value: patient._id,
                                                            label: `${patient.firstname} ${patient.lastname} (${patient.mpino})`
                                                        }))}
                                                        isDisabled={!selectedClinicId && isAdmin}
                                                        placeholder={(!selectedClinicId && isAdmin) ? "Select clinic first..." : "Select patient..."}
                                                        className="select2-selection"
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-referenceNo" style={{ fontWeight: "bold" }}>
                                                        Select Visit
                                                    </Label>
                                                    <select name="visit" className="form-control" value={Invoice.visit || ""} onChange={(e) => onValueChange(e)}>
                                                        <option value="">Choose...</option>

                                                        {visits.map((visit) => (
                                                            <option key={visit._id} value={visit._id}>
                                                                {visit.visit_no || "Visit No Missing"}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <Label style={{ fontWeight: "bold" }}>
                                                        VC Reference
                                                    </Label>
                                                    <Input type="text" className="form-control" value={Invoice.vc_reference || ""} readOnly />
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <Label style={{ fontWeight: "bold" }}>
                                                        Lab Order No
                                                    </Label>
                                                    <Input type="text" className="form-control" value={Invoice.lab_order_no || ""} readOnly />
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-postalAddress" style={{ fontWeight: "bold" }}>
                                                        Treating provider
                                                    </Label>
                                                    <select name="treating_provider" className="form-control" onChange={(e) => onValueChange(e)}>
                                                        <option defaultValue>Choose...</option>
                                                        <option defaultValue>Cathbert Ribimdi, Optometrist (70)</option>
                                                    </select>
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-postalAddress" style={{ fontWeight: "bold" }}>
                                                        Date of service
                                                    </Label>
                                                    <Input type="date" rows="2" className="form-control" name="service_date" onChange={(e) => onValueChange(e)} />
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-postalAddress" style={{ fontWeight: "bold" }}>
                                                        Place of Service
                                                    </Label>
                                                    <select name="service_place" className="form-control" onChange={(e) => onValueChange(e)}>
                                                        <option defaultValue>Choose...</option>
                                                        <option>Consulting Room </option>
                                                    </select>

                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-postalAddress" style={{ fontWeight: "bold" }}>
                                                        Diagnosis Code
                                                    </Label>
                                                    <Input type="text" rows="2" className="form-control" name="diagnosis_code" onChange={(e) => onValueChange(e)} />
                                                </div>
                                            </Col>


                                        </Row>
                                    </Col>
                                </Row>


                                <div className="mb-4">
                                    <h4 style={{ fontWeight: "bold", textAlign: "left", color: "#f46a6a" }}>Script Details</h4>
                                </div>
                                {(formRows || []).map((formRow, key) => (
                                    <Row key={formRow.id}>
                                        <Col md={1}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-item" style={{ fontWeight: "bold" }}>Eye</Label>
                                                <Input type="text" className="form-control" name="eye" value={formRow.eye} onChange={(e) => onValueChange(e, formRow.id)} disabled />
                                            </div>
                                        </Col>
                                        <Col md={2}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-item" style={{ fontWeight: "bold" }}>Lens</Label>
                                                <select className="form-control" name="lens" value={formRow.lens} onChange={(e) => handleFormFieldChange(formRow.id, e)}>
                                                    <option value="">Choose...</option>
                                                    <option value="Contact Lens">Contact Lens</option>
                                                    <option value="Not Specified">Not Specified</option>
                                                    <option value="Spectacle">Spectacle</option>
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={2}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-quantity" style={{ fontWeight: "bold" }}>Status</Label>
                                                <select className="form-control" name="status" value={formRow.status} onChange={(e) => handleFormFieldChange(formRow.id, e)}>
                                                    <option value="">Choose...</option>
                                                    <option value="Current">Current</option>
                                                    <option value="Previous">Previous</option>
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={1}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-discount" style={{ fontWeight: "bold" }}>Spherical</Label>
                                                <Input type="text" className="form-control" placeholder="0" value={formRow.spherical} name="spherical" onChange={(e) => handleFormFieldChange(formRow.id, e)} />
                                            </div>
                                        </Col>
                                        <Col md={1}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-vat" style={{ fontWeight: "bold" }}>Cylinder</Label>
                                                <Input type="text" className="form-control" placeholder="0" value={formRow.cylinder} name="cylinder" onChange={(e) => handleFormFieldChange(formRow.id, e)} />
                                            </div>
                                        </Col>
                                        <Col md={1}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-vat" style={{ fontWeight: "bold" }}>Axis</Label>
                                                <Input type="text" className="form-control" placeholder="0" value={formRow.axis} name="axis" o onChange={(e) => handleFormFieldChange(formRow.id, e)} />
                                            </div>
                                        </Col>
                                        <Col md={1}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-vat" style={{ fontWeight: "bold" }}>Add</Label>
                                                <Input type="text" className="form-control" placeholder="0" value={formRow.add} name="add" onChange={(e) => handleFormFieldChange(formRow.id, e)} />
                                            </div>
                                        </Col>
                                        <Col md={1}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-vat" style={{ fontWeight: "bold" }}>Prism</Label>
                                                <Input type="text" className="form-control" placeholder="0" value={formRow.prism} name="prism" onChange={(e) => handleFormFieldChange(formRow.id, e)} />
                                            </div>
                                        </Col>
                                        <Col md={1}>
                                            <div className="mb-3 text-center">
                                                <Label htmlFor="formrow-vat" style={{ fontWeight: "bold" }}>Info</Label>
                                                <div>
                                                    <i className="fas fa-info-circle text-primary" style={{ fontSize: "1.5rem", cursor: "pointer" }}></i>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                ))}
                                <hr style={{ border: "2px solid #555", backgroundColor: "#555", margin: "20px 0", opacity: "0.8" }} />
                                {(labLensDetails || frameDetails) && (
                                    <>
                                        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 12 }}>
                                            {labLensDetails && (
                                                <div style={{ flex: 1, minWidth: 280, border: "1px solid #e0e0e0", borderRadius: 10, overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.07)" }}>
                                                    <div style={{ background: "#f46a6a", padding: "7px 14px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                        <span style={{ color: "#fff", fontWeight: 700, fontSize: 13, letterSpacing: 0.5 }}>LAB LENS</span>
                                                        <span style={{ color: "#ffe", fontSize: 12 }}>#{labLensDetails.orderNo}</span>
                                                    </div>
                                                    <div style={{ padding: "10px 14px", background: "#fff" }}>
                                                        <div style={{ fontSize: 12, color: "#555", marginBottom: 6 }}>
                                                            <span style={{ fontWeight: 600 }}>Code:</span> {labLensDetails.lensCode || "—"}
                                                        </div>
                                                        <div style={{ display: "flex", gap: 8 }}>
                                                            <div style={{ flex: 1, background: "#fff7f8", border: "1px solid #f1b0b7", borderRadius: 7, padding: "7px 10px" }}>
                                                                <div style={{ fontSize: 11, fontWeight: 700, color: "#c0392b", marginBottom: 5 }}>OD</div>
                                                                {[["Material", labLensDetails.od.material], ["Type", labLensDetails.od.lensType], ["Photo", labLensDetails.od.photo], ["Price", `R ${labLensDetails.od.totalPrice || "0"}`]].map(([k, v]) => (
                                                                    <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: 11, marginBottom: 2 }}>
                                                                        <span style={{ color: "#888" }}>{k}</span>
                                                                        <span style={{ fontWeight: 600, color: "#333" }}>{v || "—"}</span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div style={{ flex: 1, background: "#f7fbff", border: "1px solid #b9d3ff", borderRadius: 7, padding: "7px 10px" }}>
                                                                <div style={{ fontSize: 11, fontWeight: 700, color: "#2c5cc5", marginBottom: 5 }}>OS</div>
                                                                {[["Material", labLensDetails.os.material], ["Type", labLensDetails.os.lensType], ["Photo", labLensDetails.os.photo], ["Price", `R ${labLensDetails.os.totalPrice || "0"}`]].map(([k, v]) => (
                                                                    <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: 11, marginBottom: 2 }}>
                                                                        <span style={{ color: "#888" }}>{k}</span>
                                                                        <span style={{ fontWeight: 600, color: "#333" }}>{v || "—"}</span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {frameDetails && (
                                                <div style={{ flex: 1, minWidth: 260, border: "1px solid #e0e0e0", borderRadius: 10, overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.07)" }}>
                                                    <div style={{ background: "#556ee6", padding: "7px 14px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                        <span style={{ color: "#fff", fontWeight: 700, fontSize: 13, letterSpacing: 0.5 }}>FRAME</span>
                                                        <span style={{ color: "#dde", fontSize: 12 }}>{frameDetails.frameBrand}</span>
                                                    </div>
                                                    <div style={{ padding: "10px 14px", background: "#fff" }}>
                                                        <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginBottom: 8 }}>
                                                            {[frameDetails.frameCode, frameDetails.frameColor, frameDetails.frameSize, frameDetails.frameMaterial, frameDetails.frameType, frameDetails.frameShape].filter(Boolean).map((tag, i) => (
                                                                <span key={i} style={{ background: "#f0f3ff", color: "#556ee6", borderRadius: 4, padding: "2px 8px", fontSize: 11, fontWeight: 600 }}>{tag}</span>
                                                            ))}
                                                        </div>
                                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderTop: "1px solid #f0f0f0", paddingTop: 7, marginTop: 4 }}>
                                                            <span style={{ fontSize: 12, color: "#888" }}>Frame Price</span>
                                                            <span style={{ fontSize: 14, fontWeight: 700, color: "#333" }}>R {frameDetails.framePrice || "0"}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <hr style={{ border: "2px solid #555", backgroundColor: "#555", margin: "20px 0", opacity: "0.8" }} />
                                    </>
                                )}
                                <div className="mb-4">
                                    <h4 style={{ fontWeight: "bold", textAlign: "left", color: "#f46a6a" }}>INVOICE</h4>
                                </div>
                                {(formRows2 || []).map((formRow, key) => (
                                    <Row key={formRow.id}>
                                        <Col md={1}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-vat" style={{ fontWeight: "bold" }}>QTY</Label>
                                                <Input type="text" className="form-control" placeholder="0" name="qty" value={formRow.qty} onChange={(e) => handleFormRow2Change(formRow.id, e)} />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-item" style={{ fontWeight: "bold" }}>Item code</Label>
                                                <Select
                                                    value={formRow.line_type ? {
                                                        value: formRow.line_type,
                                                        label: formRow.description
                                                            ? `${formRow.line_type} - ${formRow.description}`
                                                            : formRow.line_type,
                                                    } : null}
                                                    options={tariffOptionsByRow[formRow.id] || []}
                                                    onInputChange={(inputValue, meta) => {
                                                        if (meta.action === "input-change") {
                                                            loadTariffOptions(formRow.id, inputValue);
                                                        }
                                                    }}
                                                    onMenuOpen={() => loadTariffOptions(formRow.id, formRow.line_type || "")}
                                                    onChange={(selectedOption) => handleTariffSelect(formRow.id, selectedOption)}
                                                    placeholder="Search item code..."
                                                    isClearable
                                                    className="select2-selection"
                                                />
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-discount" style={{ fontWeight: "bold" }}>Description</Label>
                                                <Input type="text" className="form-control" name="description" value={formRow.description} onChange={(e) => handleFormRow2Change(formRow.id, e)} />
                                            </div>
                                        </Col>
                                        <Col md={2}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-item" style={{ fontWeight: "bold" }}>Tarif Code </Label>
                                                <Input type="text" className="form-control" name="tarif_code" value={formRow.tarif_code} onChange={(e) => handleFormRow2Change(formRow.id, e)} />
                                            </div>
                                        </Col>
                                        {/* <Col md={2}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-quantity" style={{ fontWeight: "bold" }}>Nappi Code</Label>
                                                <Input type="text" className="form-control" name="nappi_code" onChange={(e) => onValueChange(e, formRow.id)} />
                                            </div>
                                        </Col> */}

                                        {/* <Col md={1}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-vat" style={{ fontWeight: "bold" }}>Diag.code</Label>
                                                <Input type="text" className="form-control" placeholder="0" name="diag_code" value={formRow.diag_code} onChange={(e) => handleFormRow2Change(formRow.id, e)} />
                                            </div>
                                        </Col> */}

                                        <Col md={1}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-vat" style={{ fontWeight: "bold" }}>Amount</Label>
                                                <Input type="text" className="form-control" placeholder="0" name="price_info" value={formRow.price_info} onChange={(e) => handleFormRow2Change(formRow.id, e)} />
                                            </div>
                                        </Col>

                                        <Col md={1} className="align-self-center">
                                            <div className="d-grid">
                                                <button
                                                    type="button"
                                                    className="btn btn-danger "
                                                    onClick={() => onDeleteFormRow2(formRow.id)}
                                                // style={{
                                                //     width: "40px",
                                                //     height: "40px",
                                                //     display: "flex",
                                                //     alignItems: "center",
                                                //     justifyContent: "center",
                                                //     borderRadius: "6px"
                                                // }}
                                                >
                                                    <i className="fas fa-trash-alt"></i>

                                                </button>
                                            </div>
                                        </Col>


                                    </Row>
                                ))}
                                <Row>
                                    <Col md={12} className="text-end">

                                        <Button color="success" onClick={onAddFormRow2}>
                                            <i className="fas fa-plus me-1"></i>
                                        </Button>
                                    </Col>

                                </Row>
                                <hr style={{ border: "2px solid #555", backgroundColor: "#555", margin: "20px 0", opacity: "0.8" }} />

                                {/* ── Discount + VAT + Grand Total ── */}
                                <Row className="justify-content-end">
                                    <Col md={5}>
                                        <table style={{ width: "100%", fontSize: "14px" }}>
                                            <tbody>
                                                {formRows2.filter(r => r.description || r.price_info).map((row) => (
                                                    <tr key={row.id}>
                                                        <td style={{ padding: "4px 0", color: "#888", fontSize: 12 }}>{row.description || row.line_type || "—"}</td>
                                                        <td style={{ textAlign: "right", color: "#888", fontSize: 12 }}>R {((parseFloat(row.price_info) || 0) * (parseFloat(row.qty) || 1)).toFixed(2)}</td>
                                                    </tr>
                                                ))}
                                                {labLensDetails && (
                                                    <>
                                                        <tr>
                                                            <td style={{ padding: "4px 0", color: "#888", fontSize: 12 }}>OD Lens</td>
                                                            <td style={{ textAlign: "right", color: "#888", fontSize: 12 }}>R {labLensDetails.od.totalPrice || "0.00"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ padding: "4px 0", color: "#888", fontSize: 12 }}>OS Lens</td>
                                                            <td style={{ textAlign: "right", color: "#888", fontSize: 12 }}>R {labLensDetails.os.totalPrice || "0.00"}</td>
                                                        </tr>
                                                    </>
                                                )}
                                                {frameDetails && (
                                                    <tr>
                                                        <td style={{ padding: "4px 0", color: "#888", fontSize: 12 }}>Frame</td>
                                                        <td style={{ textAlign: "right", color: "#888", fontSize: 12 }}>R {frameDetails.framePrice || "0.00"}</td>
                                                    </tr>
                                                )}
                                                {(labLensDetails || frameDetails) && (
                                                    <tr><td colSpan={2} style={{ padding: "2px 0" }}><hr style={{ margin: "4px 0", borderTop: "1px dashed #ccc" }} /></td></tr>
                                                )}
                                                <tr>
                                                    <td style={{ padding: "6px 0", color: "#555", fontWeight: "600" }}>Subtotal</td>
                                                    <td style={{ textAlign: "right", fontWeight: "600" }}>R {subtotal}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ padding: "6px 0", color: "#555", fontWeight: "600" }}>
                                                        <span>Discount &nbsp;</span>
                                                        <select
                                                            value={discountType}
                                                            onChange={handleDiscountTypeChange}
                                                            style={{ fontSize: "12px", padding: "2px 4px", borderRadius: "4px", border: "1px solid #ccc", marginRight: "6px" }}
                                                        >
                                                            <option value="percent">% Percent</option>
                                                            <option value="amount">R Fixed</option>
                                                        </select>
                                                        <Input
                                                            type="number"
                                                            min="0"
                                                            value={discountValue}
                                                            onChange={handleDiscountValueChange}
                                                            style={{ display: "inline-block", width: "80px", fontSize: "13px", padding: "2px 6px", height: "28px" }}
                                                        />
                                                    </td>
                                                    <td style={{ textAlign: "right", color: "#e74c3c", fontWeight: "600" }}>
                                                        {`- R ${discountType === 'percent'
                                                            ? ((parseFloat(subtotal) || 0) * (parseFloat(discountValue) || 0) / 100).toFixed(2)
                                                            : (parseFloat(discountValue) || 0).toFixed(2)}`}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ padding: "6px 0", color: "#555", fontWeight: "600" }}>
                                                        <span>VAT &nbsp;</span>
                                                        <Input
                                                            type="number"
                                                            min="0"
                                                            max="100"
                                                            value={vatPercent}
                                                            onChange={handleVatChange}
                                                            style={{ display: "inline-block", width: "60px", fontSize: "13px", padding: "2px 6px", height: "28px", marginRight: "4px" }}
                                                        />
                                                        <span style={{ fontSize: "12px", color: "#888" }}>%</span>
                                                    </td>
                                                    <td style={{ textAlign: "right", color: "#27ae60", fontWeight: "600" }}>
                                                        {(() => {
                                                            const sub = parseFloat(subtotal) || 0;
                                                            const dv = parseFloat(discountValue) || 0;
                                                            const disc = discountType === 'percent' ? sub * dv / 100 : dv;
                                                            const after = Math.max(sub - disc, 0);
                                                            return `+ R ${(after * (parseFloat(vatPercent) || 0) / 100).toFixed(2)}`;
                                                        })()}
                                                    </td>
                                                </tr>
                                                <tr style={{ borderTop: "2px solid #333" }}>
                                                    <td style={{ padding: "8px 0", fontWeight: "800", fontSize: "16px" }}>Grand Total</td>
                                                    <td style={{ textAlign: "right", fontWeight: "800", fontSize: "18px", color: "#333" }}>R {total}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </Col>
                                </Row>

                                <div className="mt-3 text-end">
                                    <button className="btn btn-success w-md mx-2" onClick={(e) => addInvoiceDetails(e)}>Save</button>
                                </div>
                            </Form>

                        </CardBody>
                    </Card>
                </Row>
            </Container>
            {/* </div > */}
        </React.Fragment >
    )
}

export default Invoice_new
